export class Default {
  public static MEDIUM_EDITOR_OPTIONS = {
    autoLink: true
  }
}
